import { InlineChainBadge } from "@/components/ui/enhanced-json-view";
import { PRIORITY, type ValueRenderer } from "../types";

const CHAIN_KEY_RE = /^chain ?id$/i;
const KNOWN_CHAIN_IDS = new Set([1, 8453, 42161, 10, 137, 56, 43114, 100, 324, 7777777]);

export const ChainRenderer: ValueRenderer = {
  id: "chain",
  match: (value, ctx) => {
    if (typeof value !== "number" || !Number.isInteger(value)) return null;
    if (ctx.key && CHAIN_KEY_RE.test(ctx.key)) return { priority: PRIORITY.CONTEXT_HINTED, confidence: "high" };
    if (KNOWN_CHAIN_IDS.has(value) && ctx.key && /chain/i.test(ctx.key)) {
      return { priority: PRIORITY.CONTEXT_HINTED, confidence: "low" };
    }
    return null;
  },
  Component: ({ value }) => <InlineChainBadge chainId={value as number} />,
};
